/* eslint-disable react/no-array-index-key */
import { PJVToolPage } from "@pages/pjv-tool";
import { RekenmoduleEbPage, setInlineApiUrl } from "@pages/rekenmodule-eb";
import axios from "axios";
import { PiletApi } from "opencak-app";
import * as React from "react";
import "./sass/form-styling.scss";

export interface ITestProps {
  pageBaseUrl: string;
}

const piletName = "opencak-rekenmodules-pilet";

export function setup(app: PiletApi) {
  const basePath = app.getData("base-path");
  const apiUrl = app.getData("api-path");
  setInlineApiUrl(apiUrl);
  const authEnabled = app.getData("api-auth-enabled");
  const PJVTool = () => <PJVToolPage basePath={basePath} apiUrl={apiUrl} piletName={piletName} />;
  const RekenmoduleEb = () => <RekenmoduleEbPage basePath={basePath} apiUrl={apiUrl} piletName={piletName} />;

  axios.defaults.withCredentials = authEnabled;

  app.registerPage(`${basePath}/zelf-regelen/eigen-bijdrage-rekenhulp/:flowStep?`, RekenmoduleEb);

  app.registerPage(`${basePath}/zelf-regelen/peiljaarverleggen-check/:flowStep?`, PJVTool);
}
